import { Collection, Plugin } from 'ckeditor5';
export class PlaceholderStore extends Plugin {
    static get pluginName() {
        return 'PlaceholderStore';
    }
    init() {
        this.placeholderData = new Collection();
        this.registerPlaceholders();
    }
    registerPlaceholders() {
        const { conversion } = this.editor;
        // Register all placeholders in to the store when editor loads HTML
        conversion.for('upcast').add((dispatcher) => {
            dispatcher.on('element:span', (_, data) => {
                var _a;
                const { viewItem } = data;
                const id = viewItem.getAttribute('data-placeholder');
                const value = ((_a = viewItem.getChildren().next().value) === null || _a === void 0 ? void 0 : _a.data) || id;
                if (id) {
                    this.addPlaceholderToStore(id, value);
                }
            });
        });
        // Register all placeholders in to the store when editor inserts a new placeholder
        conversion.for('downcast').add((dispatcher) => {
            dispatcher.on('insert:placeholder', (_, data) => {
                var _a;
                const { item } = data;
                const id = item.getAttribute('id');
                const value = ((_a = item.getChildren().next().value) === null || _a === void 0 ? void 0 : _a.data) || id;
                if (id) {
                    this.addPlaceholderToStore(id, value);
                }
            });
        });
    }
    addPlaceholderToStore(id, value) {
        const exists = this.placeholderData.has(id);
        if (exists) {
            return;
        }
        this.placeholderData.add({ id, value });
    }
    getPlaceholderFromStore(id) {
        return this.placeholderData.get(id);
    }
    getAllPlaceholdersFromStore() {
        return this.placeholderData.map(({ id }) => id);
    }
}
